import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "content_bt",
  style: {
    "width": "300px",
    "margin-top": "16px"
  }
};
const _hoisted_2 = {
  style: {
    "font-size": "14px",
    "font-weight": "bold",
    "text-align": "left",
    "line-height": "200%"
  }
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_4 = {
  class: "title_tx2"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "放电MOS:", -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "充电MOS:", -1);
const _hoisted_7 = {
  key: 1,
  style: {
    "border-style": "solid",
    "border-width": "1px",
    "padding": "8px"
  }
};
const _hoisted_8 = {
  style: {
    "font-size": "12px",
    "margin-right": "4px"
  }
};
const _hoisted_9 = {
  style: 'font-size: 12px; font-weight: bold;'
};
const _hoisted_10 = {
  style: {
    "font-size": "12px",
    "width": "20px"
  }
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "det_title"
}, "基础信息", -1);
const _hoisted_12 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-stopwatch"
}), /*#__PURE__*/_createTextVNode(" 实际容量 ")], -1);
const _hoisted_13 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-stopwatch"
}), /*#__PURE__*/_createTextVNode(" 额定容量 ")], -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-stopwatch"
}), /*#__PURE__*/_createTextVNode(" 电压最高电芯电压 ")], -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-stopwatch"
}), /*#__PURE__*/_createTextVNode(" 电压最低电芯电压 ")], -1);
const _hoisted_16 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 放电剩余时间 ")], -1);
const _hoisted_17 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-stopwatch"
}), /*#__PURE__*/_createTextVNode(" 充电剩余时间 ")], -1);
const _hoisted_18 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-stopwatch"
}), /*#__PURE__*/_createTextVNode(" 当前充电间隔 ")], -1);
const _hoisted_19 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-stopwatch"
}), /*#__PURE__*/_createTextVNode(" 最长充电间隔 ")], -1);
const _hoisted_20 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-stopwatch"
}), /*#__PURE__*/_createTextVNode(" 硬件版本 ")], -1);
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "det_title"
}, "报警信息", -1);
const _hoisted_22 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 电芯过压保护 ")], -1);
const _hoisted_23 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 总压过压保护 ")], -1);
const _hoisted_24 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 充满保护 ")], -1);
const _hoisted_25 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 电芯欠压保护 ")], -1);
const _hoisted_26 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 总压欠压保护 ")], -1);
const _hoisted_27 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 充电温度保护 ")], -1);
const _hoisted_28 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 放电温度保护 ")], -1);
const _hoisted_29 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" MOS过温保护 ")], -1);
const _hoisted_30 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 高温保护 ")], -1);
const _hoisted_31 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 低温保护 ")], -1);
const _hoisted_32 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 放电短路保护 ")], -1);
const _hoisted_33 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 放电过流保护 ")], -1);
const _hoisted_34 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 充电过流保护 ")], -1);
const _hoisted_35 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 环境高温保护 ")], -1);
const _hoisted_36 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 环境低温保护 ")], -1);
const _hoisted_37 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 温度采集失效 ")], -1);
const _hoisted_38 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 电压采集失效 ")], -1);
const _hoisted_39 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 放电MOS失效 ")], -1);
const _hoisted_40 = /*#__PURE__*/_createElementVNode("template", {
  slot: "label"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-tickets"
}), /*#__PURE__*/_createTextVNode(" 充电MOS失效 ")], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _component_el_col = _resolveComponent("el-col");
  const _component_chart_bms_more = _resolveComponent("chart-bms-more");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_card = _resolveComponent("el-card");
  return _openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      type: "flex",
      align: "middle",
      style: {
        "padding": "8px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 10,
        type: "flex",
        align: "middle"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_createTextVNode(" 电池编码：" + _toDisplayString($data.batteryBt) + " ", 1), _hoisted_3, _createTextVNode(" 更新时间：" + _toDisplayString($data.mRefreshDate) + " ", 1), _createVNode(_component_el_tag, {
          type: $data.mCurA == 0 ? 'info' : $data.mCurA > 0 ? 'warning' : 'danger'
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mCurA == 0 ? '搁置中' : $data.mCurA > 0 ? '充电中' : '放电中'), 1)]),
          _: 1
        }, 8, ["type"])])]), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_4, "SOC:" + _toDisplayString($data.mCurSoc) + "%", 1), _createVNode(_component_el_image, {
            style: {
              "margin-top": "15px",
              "width": "300px",
              "height": "160px"
            },
            class: "img_battery",
            fit: "fill",
            src: require('@/assets/battery/icon_battery_' + $data.mSocImg + '.png')
          }, null, 8, ["src"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 24,
          type: "flex",
          align: "middle",
          justify: "middle",
          style: {
            "margin-top": "30px",
            "margin-bottom": "30px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions, {
            column: 2,
            border: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "充电MOS",
              span: "1"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: $data.isMosRec,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.isMosRec = $event),
                disabled: "",
                "active-color": "#41b584",
                "inactive-color": "#f34d37"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "放电MOS",
              span: "1"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: $data.isMosDis,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.isMosDis = $event),
                disabled: "",
                "active-color": "#41b584",
                "inactive-color": "#f34d37"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "当前电流",
              span: "1"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tag, {
                size: "small",
                type: $data.mCurA == 0 ? 'info' : $data.mCurA > 0 ? 'warning' : 'danger'
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mCurA) + "A ", 1)]),
                _: 1
              }, 8, ["type"])]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "当前电压",
              span: "1"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tag, {
                size: "small"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mCurV) + "V", 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "剩余容量",
              span: "1"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tag, {
                size: "small"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mSurplusCapacity) + "ah", 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "循环次数",
              span: "1"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tag, {
                size: "small"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mRecIndex) + "次", 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          type: "flex",
          align: "middle",
          style: {
            "padding": "8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12,
            type: "flex",
            align: "middle"
          }, {
            default: _withCtx(() => [_hoisted_5, _createVNode(_component_el_tag, {
              size: "mini",
              type: "danger",
              effect: "dark",
              onClick: _cache[2] || (_cache[2] = $event => $options.onSendOrderTag('放电MOS关闭'))
            }, {
              default: _withCtx(() => [_createTextVNode(" 关闭 ")]),
              _: 1
            }), _createVNode(_component_el_tag, {
              size: "mini",
              type: "success",
              effect: "dark",
              onClick: _cache[3] || (_cache[3] = $event => $options.onSendOrderTag('放电MOS打开'))
            }, {
              default: _withCtx(() => [_createTextVNode(" 开启 ")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12,
            type: "flex",
            align: "middle"
          }, {
            default: _withCtx(() => [_hoisted_6, _createVNode(_component_el_tag, {
              size: "mini",
              type: "danger",
              effect: "dark",
              onClick: _cache[4] || (_cache[4] = $event => $options.onSendOrderTag('充电MOS关闭'))
            }, {
              default: _withCtx(() => [_createTextVNode(" 关闭 ")]),
              _: 1
            }), _createVNode(_component_el_tag, {
              size: "mini",
              type: "success",
              effect: "dark",
              onClick: _cache[5] || (_cache[5] = $event => $options.onSendOrderTag('充电MOS打开'))
            }, {
              default: _withCtx(() => [_createTextVNode(" 开启 ")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          type: "flex",
          align: "middle",
          style: {
            "padding": "8px"
          }
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 14,
        type: "flex",
        align: "middle"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            type: "flex",
            align: "middle",
            justify: "middle"
          }, {
            default: _withCtx(() => [$data.dataListBMS.length > 0 ? (_openBlock(), _createBlock(_component_chart_bms_more, {
              key: 0,
              ref: "bmschart"
            }, null, 512)) : _createCommentVNode("", true), $data.initHis && $data.dataListBMS.length == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, " 设备无数据 ")) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 23,
            offset: 1,
            type: "flex",
            align: "middle",
            justify: "middle"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tempList, (itemList, indexList) => {
              return _openBlock(), _createBlock(_component_el_row, {
                key: 'temp' + indexList,
                style: {
                  "margin-top": "8px"
                },
                type: "flex",
                align: "middle"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_col, {
                    key: 'temp2' + index,
                    span: 7,
                    class: "content_center"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_image, {
                      class: "item_battery",
                      src: require('@/assets/battery/icon_temp_item.png')
                    }, null, 8, ["src"]), _createElementVNode("span", _hoisted_8, _toDisplayString(item.name) + ": ", 1), _createElementVNode("span", _hoisted_9, _toDisplayString(item.value) + "℃ ", 1)]),
                    _: 2
                  }, 1024);
                }), 128))]),
                _: 2
              }, 1024);
            }), 128)), _createVNode(_component_el_row, {
              type: "flex",
              align: "start",
              style: {
                "margin-top": "20px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 7,
                type: "flex",
                align: "middle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tag, {
                  size: "small",
                  effect: "plain",
                  type: "success"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 最高单体电压：" + _toDisplayString($data.maxVol) + "V ", 1)]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 7,
                type: "flex",
                align: "middle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tag, {
                  size: "small",
                  effect: "plain",
                  type: "danger"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 最低单体电压：" + _toDisplayString($data.mixVol) + "V ", 1)]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 7,
                type: "flex",
                align: "middle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tag, {
                  size: "small",
                  effect: "plain",
                  type: "info"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 单体电压压差：" + _toDisplayString($data.marginV) + "V ", 1)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.batteryList, (itemList, indexList) => {
              return _openBlock(), _createBlock(_component_el_row, {
                key: 'battery' + indexList,
                style: {
                  "margin-top": "8px"
                },
                type: "flex"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_col, {
                    key: 'battery2' + index,
                    span: 5,
                    class: "content_start"
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", _hoisted_10, " [" + _toDisplayString(indexList * 5 + index + 1) + "] ", 1), _createVNode(_component_el_image, {
                      class: "item_battery",
                      src: require('@/assets/battery/icon_battery_item.png')
                    }, null, 8, ["src"]), _createElementVNode("span", {
                      style: _normalizeStyle('font-size: 12px; font-weight: bold;' + (item.value == $data.maxVol ? 'color:#47ba80;' : item.value == $data.mixVol ? 'color:#f34d37;' : 'color:#222222;'))
                    }, _toDisplayString(item.value) + "V ", 5)]),
                    _: 2
                  }, 1024);
                }), 128))]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        type: "flex",
        justify: "space-between",
        align: "middle",
        style: {
          "padding": "8px",
          "margin-top": "8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 20
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 2
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            size: "mini",
            style: {
              "margin-left": "8px"
            },
            onClick: _cache[6] || (_cache[6] = $event => $options.onSendOrder())
          }, {
            default: _withCtx(() => [_createTextVNode(" 下发指令 ")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_descriptions, {
        column: 8,
        size: "mini",
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_12, _createTextVNode(" " + _toDisplayString($data.mActualCapacity) + "ah ", 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_13, _createTextVNode(" " + _toDisplayString($data.mRatedCapacity) + "ah ", 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_14, _createTextVNode(" " + _toDisplayString($data.mMaxVoltage) + "V ", 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_15, _createTextVNode(" " + _toDisplayString($data.mMinVoltage) + "V ", 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_16, _createTextVNode(" " + _toDisplayString($data.mDischargeSurplusTime) + "min ", 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_17, _createTextVNode(" " + _toDisplayString($data.mChargeSurplusTime) + "min ", 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_18, _createTextVNode(" " + _toDisplayString($data.mCurChargeInterval) + "h ", 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_19, _createTextVNode(" " + _toDisplayString($data.mMaxChargeInterval) + "h ", 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "6"
        }, {
          default: _withCtx(() => [_hoisted_20, _createTextVNode(" " + _toDisplayString($data.mHardwareVer) + "h ", 1)]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        type: "flex",
        justify: "space-between",
        align: "middle",
        style: {
          "padding": "8px",
          "margin-top": "8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 20
        }, {
          default: _withCtx(() => [_hoisted_21]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_descriptions, {
        column: 10,
        size: "mini",
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_22, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm1 == '0' ? 'success' : $data.mAlarm1 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm1 == '0' ? '正常' : $data.mAlarm1 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_23, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm2 == '0' ? 'success' : $data.mAlarm2 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm2 == '0' ? '正常' : $data.mAlarm2 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_24, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm3 == '0' ? 'success' : $data.mAlarm3 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm3 == '0' ? '正常' : $data.mAlarm3 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_25, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm4 == '0' ? 'success' : $data.mAlarm4 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm4 == '0' ? '正常' : $data.mAlarm4 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_26, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm5 == '0' ? 'success' : $data.mAlarm5 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm5 == '0' ? '正常' : $data.mAlarm5 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_27, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm6 == '0' ? 'success' : $data.mAlarm6 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm6 == '0' ? '正常' : $data.mAlarm6 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_28, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm7 == '0' ? 'success' : $data.mAlarm7 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm7 == '0' ? '正常' : $data.mAlarm7 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_29, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm8 == '0' ? 'success' : $data.mAlarm8 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm8 == '0' ? '正常' : $data.mAlarm8 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_30, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm9 == '0' ? 'success' : $data.mAlarm9 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm9 == '0' ? '正常' : $data.mAlarm9 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_31, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm10 == '0' ? 'success' : $data.mAlarm10 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm10 == '0' ? '正常' : $data.mAlarm10 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_32, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm11 == '0' ? 'success' : $data.mAlarm11 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm11 == '0' ? '正常' : $data.mAlarm11 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_33, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm12 == '0' ? 'success' : $data.mAlarm12 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm12 == '0' ? '正常' : $data.mAlarm12 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_34, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm13 == '0' ? 'success' : $data.mAlarm13 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm13 == '0' ? '正常' : $data.mAlarm13 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_35, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm14 == '0' ? 'success' : $data.mAlarm14 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm14 == '0' ? '正常' : $data.mAlarm14 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_36, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm15 == '0' ? 'success' : $data.mAlarm15 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm15 == '0' ? '正常' : $data.mAlarm15 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_37, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm16 == '0' ? 'success' : $data.mAlarm16 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm16 == '0' ? '正常' : $data.mAlarm16 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_38, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm17 == '0' ? 'success' : $data.mAlarm17 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm17 == '0' ? '正常' : $data.mAlarm17 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_39, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm18 == '0' ? 'success' : $data.mAlarm18 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm18 == '0' ? '正常' : $data.mAlarm18 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          span: "2"
        }, {
          default: _withCtx(() => [_hoisted_40, _createVNode(_component_el_tag, {
            size: "small",
            type: $data.mAlarm19 == '0' ? 'success' : $data.mAlarm19 == '1' ? 'danger' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.mAlarm19 == '0' ? '正常' : $data.mAlarm19 == '1' ? '异常' : '未读取'), 1)]),
            _: 1
          }, 8, ["type"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}